import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    startSpinner(event) {
        // The event target is the form; find the enclosing table row for slug context
        const form = event.target
        const button = form.querySelector('button')
        const tr = form.closest('tr[data-row-slug]')
        const slug = tr?.getAttribute('data-row-slug') || 'unknown'

        const icon = button?.querySelector('.refresh-icon')
        if (icon) {
            // Hide the icon and show Bootstrap spinner
            icon.style.display = 'none'

            // Create or show spinner
            let spinner = button.querySelector('.spinner-border')
            if (!spinner) {
                spinner = document.createElement('div')
                spinner.className = 'spinner-border spinner-border-sm'
                spinner.setAttribute('role', 'status')
                button.appendChild(spinner)
            }
            spinner.style.display = 'inline-block'
        }
    }

    stopSpinner(event) {
        // The event target is the form; find the enclosing table row for slug context
        const form = event.target
        const button = form.querySelector('button')
        const tr = form.closest('tr[data-row-slug]')
        const slug = tr?.getAttribute('data-row-slug') || 'unknown'

        const icon = button?.querySelector('.refresh-icon')
        const spinner = button?.querySelector('.spinner-border')

        if (icon) {
            icon.style.display = 'inline-block'
        }
        if (spinner) {
            spinner.style.display = 'none'
        }
    }
}
